const PACKAGES_COMPARE = {
  PAGE_TITLE: 'Raychat | Pricing',

  HEADING_TITLE: 'For large and small companies',
  HEADING_DESCRIPTION:
    '14 days trial use of commercial package, free package for small startups',

  FREE: 'Free',
  FREE_FEATURES_TITLE: 'Free forever with limited features',

  FREE_FEATURES_1: 'Up to 100 new conversations per month',
  FREE_FEATURES_2: 'Responding from the Android application',
  FREE_FEATURES_3: 'Desktop applications',
  FREE_FEATURES_4: 'Reply from Telegram',
  FREE_FEATURES_5: 'Widget customization',
  FREE_PRICE: '0',
  FREE_PRICE_TEXT: 'Forever',
  FREE_PRICE_PERIOD: 'Forever',
  FREE_SUB_PRICE: '',

  PROFESSIONAL: 'Professional',
  PROFESSIONAL_FEATURES_TITLE: '+ All the features of Free package',

  PROFESSIONAL_FEATURES: [
    '500 initial call charge per month',
    'Send smart messages',
    'Archive of 180 days of conversations',
    'Management of 1 websites',
    'conversation between operators',
    'Transferring conversations between operators',
    'Setting working hours ',
    'Messages will be answered within 72 hours',
    'Technical support is included in the cost',
    'This package does not include phone support',
  ],

  PROFESSIONAL_PRICE: '5',
  PROFESSIONAL_PRICE_PERIOD: 'Monthly',
  PROFESSIONAL_SUB_PRICE: 'If you buy an annual account',

  COMMERICAL: 'Commercial',
  COMMERICAL_FEATURES_TITLE: '+ All the features of the Professional package',

  COMMERICAL_FEATURES: [
    '1000 new conversations',
    'Professional statistics of operators',
    'csv export of user information',
    'Send 6 smart messages',
    'Upload files up to 30 MB',
    'Assign operator to URL',
    'Webhook for users and chats',
    'Ability to use API',
    'Ready answers',
    'Send voice in the widget',
    ' Add user to spam list',
    'Ability to remove the text "Powered by raychat" in the widget',
    'Support',
    'Form customization',
  ],

  COMMERICAL_PRICE: '30',
  COMMERICAL_PRICE_PERIOD: 'Monthly',
  COMMERICAL_SUB_PRICE: 'If you buy an annual account',

  PREMIUM: 'Premium',
  PREMIUM_PLUS: 'Premium Plus',
  PREMIUM_FEATURES_TITLE: '+ All features of the business package',

  PREMIUM_FEATURES: [
    'Unlimited new conversation',
    'Unlimited new website',
    'Unlimited simultaneous visits',
    'Unlimited smart messages',
    'Responsive Bot',
    'Waiting mode',
    'Roadmap',
    'Chats export',
    'Connect to WhatsApp (Reply to users via WhatsApp)',
    'Professional statistics of operators + csv export',
    'Customizing widget logo',
    'Monitoring visitors',
    'Support',
  ],
  PREMIUM_PRICE: '99',
  PREMIUM_PRICE_PERIOD: 'Monthly',
  PREMIUM_SUB_PRICE: 'If you buy an annual account',

  START: 'START',
  TRY_14_DAYS_FREE: 'Try it as a trial for 14 days',

  COMPARE_PACKAGES: 'Compare raychat packages',

  MODAL_FEATURES_TITLE: 'Features',
  MODAL_FEATURES: [
    'Features',
    'Monthly',
    'Annual (25% off)',
    'Initial conversation charge',
    'Cost per conversation',
    'Websites count',
    'Operators count',
    'AI chatbot',
    'Responsive Bot',
    'Waiting mode',
    'Roadmap',
    'Form customization',
    'Replying via WhatsApp',
    'Webhook',
    'Assign operator to URL',
    'Sending voice through the widget',
    'Departments',
    'Android app',
    'iOS aoo',
    'Windows app',
    'Web app',
    'Client-side api',
    'Customizing widget',
    'Simultaneous conversation with users',
    'Replying via Telegram',
    'Changing operator status (offline/online)',
    'Operators statistics csv export',
    'User informations csv export',
    'Widget FAQ',
    'Customizing widget logo',
    'Auto messages',
    'Monitoring visitors',
    'Sending email to users',
    'Conversation between operators',
    'Transferring conversations between operators',
    'Shortcut messages',
    'Setting working hours',
    'Displaying users detailed information',
    'Showing user typed words before sending',
    'Adding user to black list',
    'Operators Professional statistic',
    'Official bill',
    'upload file limit',
    'Conversation archive',
    'Concurrent view limit',
  ],

  TRY_FOR_FREE: 'Try for free',

  MODAL_FREE_TITLE: 'Free',
  MODAL_FREE_FEATURES_1: '0',
  MODAL_FREE_FEATURES_2: '100',
  MODAL_FREE_FEATURES_3: '0',

  MODAL_FREE_PRICE: 'Free',

  MODAL_PROFESSIONAL_TITLE: 'Professional',
  MODAL_PROFESSIONAL_FEATURES_1: '100',
  MODAL_PROFESSIONAL_FEATURES_2: '0',
  MODAL_PROFESSIONAL_FEATURES_3: '0',
  MODAL_PROFESSIONAL_PRICE: '5',

  MODAL_PROFESSIONAL_ANNUAL_PRICE_AFTER_DISCOUNT: '50 $',
  MODAL_PROFESSIONAL_FEATURES: [
    'Professional',
    '5 $',
    '60 $',
    '500',
    '1 $ per conversation',
    '1 website',
    'Unlimited',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '1',
    '-',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '-',
    '-',
    '-',
    '-',
    '-',
    '1',
    '1',
    '1',
    '1',
    '-',
    '1',
    '1',
    '1',
    '-',
    '-',
    '1',
    '20 MB',
    '180 day',
    '5000',
  ],

  MODAL_COMMERICAL_TITLE: 'Commercial',
  MODAL_COMMERICAL_FEATURES_1: '100',
  MODAL_COMMERICAL_FEATURES_2: '0',
  MODAL_COMMERICAL_FEATURES_3: '100',
  MODAL_COMMERICAL_PRICE: '30',

  MODAL_COMMERCIAL_ANNUAL_PRICE_AFTER_DISCOUNT: '300 $',
  MODAL_COMMERICAL_FEATURES: [
    'Commercial',
    '30 $',
    '360 $',
    '1000',
    '1 $ per conversation',
    '5 website',
    'Unlimited',
    '-',
    '-',
    '-',
    '-',
    '1',
    '-',
    '1',
    '1',
    '1',
    '-',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '-',
    '1',
    '-',
    '-',
    '6 message',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '30 MB',
    '365 day',
    '5000',
  ],

  MODAL_PREMIUM_TITLE: 'Premium',
  MODAL_PREMIUM_FEATURES_1: '100',
  MODAL_PREMIUM_FEATURES_2: '0',
  MODAL_PREMIUM_FEATURES_3: '100',
  MODAL_PREMIUM_PRICE: '90',

  MODAL_PREMIUM_ANNUAL_PRICE_AFTER_DISCOUNT: '990 $',
  MODAL_PREMIUM_PLUS_ANNUAL_PRICE_AFTER_DISCOUNT: '990 $',
  MODAL_PREMIUM_FEATURES: [
    'Premium',
    '99 $',
    '1188 $',
    'Unlimited',
    '-',
    'Unlimited',
    'Unlimited',
    '-',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    'Unlimited',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '30 MB',
    'Unlimited',
    'Unlimited',
  ],
  MODAL_PREMIUM_PlUS_FEATURES: [
    'Premium Plus',
    '99 $',
    '1188 $',
    'Unlimited',
    '-',
    'Unlimited',
    'Unlimited',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    'Unlimited',
    '5000',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '30 MB',
    'Unlimited',
  ],

  CUSTOMER_NAME: 'Adel Talebi',
  CUSTOMER_QUOTE:
    'These days, due to the intense competition in the virtual space, keeping the user on the site has a high value, because you can engage the user more with your business, Raychat is one of the systems through which you can do this in the best way.',
  CUSTOMER_ROLE: 'Online Business Strategist',

  FAQ_TITLE: 'FAQ',
  FAQ_SUB_TITLE:
    "If you couldn't find your answer, go to the #articles# section.",

  FAQ_QUESTIONS: [
    {
      title:
        'After purchasing the package, is it possible to install Raychat on several different websites?',
      content:
        'You can install the package on the same number of sites based on the features of the purchased packages.',
    },
    {
      title: 'Is every message sent to the user considered a conversation?',
      content:
        'No, every message sent by users is not considered a conversation, but the beginning of a conversation with the intended user, and this user may have a continuous conversation with you several times during the year.',
    },
    {
      title: 'What happens after the test version expires?',
      content:
        'The free package is automatically activated for you and you can upgrade the package from the management panel.',
    },
    {
      title: 'Is it possible to use Raychat for a user with a mobile phone?',
      content:
        'Yes, Raychat is fully responsive and your users can chat with you with all modern browsers of smartphones.',
    },
    {
      title:
        'If the duration of our conversation ends, is it possible to recharge it?',
      content:
        'Yes, it is possible to charge calls only for the professional package…',
    },
    {
      title:
        'By upgrading the professional to a commercial package, will the remaining time be transferred before the package expires?',
      content:
        'No, by upgrading to the commercial package, the extended period will be registered for you in the retail package.',
    },
  ],

  QUESTION_1:
    'After purchasing the package, is it possible to install Raychat on several different websites?',
  ANSWER_1:
    'You can install the package on the same number of sites based on the features of the purchased packages.',

  QUESTION_2: 'Is every message sent to the user considered a conversation?',
  ANSWER_2:
    'No, every message sent by users is not considered a conversation, but the beginning of a conversation with the intended user, and this user may have a continuous conversation with you several times during the year.',

  QUESTION_3: 'What happens after the test version expires?',
  ANSWER_3:
    'The free package is automatically activated for you and you can upgrade the package from the management panel.',

  QUESTION_4: 'Is it possible to use Raychat for a user with a mobile phone?',
  ANSWER_4:
    'Yes, Raychat is fully responsive and your users can chat with you with all modern browsers of smartphones.',

  QUESTION_5:
    'If the duration of our conversation ends, is it possible to recharge it?',
  ANSWER_5:
    'Yes, it is possible to charge calls only for the professional package…',

  QUESTION_6:
    'By upgrading the professional to a commercial package, will the remaining time be transferred before the package expires?',
  ANSWER_6:
    'No, by upgrading to the commercial package, the extended period will be registered for you in the retail package.',

  TALK_TO_US_TITLE: 'Did you not get the answer to your question?',
  TALK_TO_US_SUB_TITLE:
    'Click on the widget in the corner of our website and ask your question in the opened page. Our support team will answer your question as soon as possible.',
};

export default PACKAGES_COMPARE;
